import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable()
export class VehicleFullListService {

    /**
     * subject dla wartosci chujnikow
     */
    private inidicatorValueSubject: BehaviorSubject<any> = new BehaviorSubject(null);


}
